// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"35":"fehler","177":"home","298":"formular3"}[chunkId] || chunkId) + "-legacy." + {"35":"8b54d636","109":"dc2af085","177":"89a9426f","298":"0d75c9a4","612":"0c7259d6","647":"46c2ba34","695":"27acf72b","768":"9f35d624","859":"9f20bf5d","861":"155817f2","874":"33106c8c","923":"a40b8b07"}[chunkId] + ".js";
};